import React, { useEffect, useState } from "react";
import prod from "../assets/prod.jpg";
import { MdArrowForwardIos } from "react-icons/md";
import { FaArrowRight } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { SlArrowUp } from "react-icons/sl";
import { SlArrowDown } from "react-icons/sl";
import { GrDocumentPdf } from "react-icons/gr";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import flame from "../assets/flame.jpg"
import flame1 from "../assets/flame1.jpg"
import flame2 from "../assets/flame2.jpg"
import flame3 from "../assets/flame3.jpg"
import pdf1 from "../pdfs/pdcj001_d_en.pdf"
import pdf2 from "../pdfs/pdcj002_e_en.pdf"
import pdf3 from "../pdfs/fdcj004_d_en.pdf"
import Footer from "./Footer";
import { Link, useLocation } from "react-router-dom";
import Navigation from "./Navigation";

const Flame = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isAddressableOpen, setIsAddressableOpen] = useState(false);
    const [isOpen1, setIsOpen1] = useState(false);
    const [isOpen2, setIsOpen2] = useState(false);

    const location = useLocation();
    const currentPath = location.pathname;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    useEffect(() => {
        if (["/address", "/n3060", "/n765", "/smoke", "/other", "/flame"].includes(currentPath)) {
            setIsOpen(true);
        }

        if (["/address", "/n3060", "/n765"].includes(currentPath)) {
            setIsAddressableOpen(true);
        }

        if (["/nn100"].includes(currentPath)) {
            setIsOpen1(true);
        }

        if (["/foam", "/foamm"].includes(currentPath)) {
            setIsOpen2(true);
        }
    }, [currentPath]);

    return (
        <>
            <div className='sticky top-0 z-50 w-full bg-white shadow-md'>
                <Navigation />
            </div>
            <div className="relative overflow-hidden">
                <img src={prod} alt="Product" className={`w-full h-auto object-cover transition-transform duration-1000 ${isVisible ? 'scale-100' : 'scale-110'}`} />

                <div className="absolute inset-0 flex items-center justify-start px-4 xl:px-20 bg-black/40">
                    <h1 className={`uppercase text-xl md:text-2xl lg:text-5xl text-white transform transition-all duration-700 ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'}`}>
                        Products
                    </h1>
                </div>
            </div>

            <div className="w-full px-4 xl:px-20 py-3 xl:py-5 overflow-hidden">
                <div className={`flex flex-wrap items-center gap-2 text-md md:text-lg transform transition-all duration-700 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`}>
                    <Link to="/" className="uppercase text-green-700 hover:underline transition-colors duration-300">
                        Home
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <Link to="/products" className="uppercase text-md md:text-lg text-green-700 hover:underline">
                        Products
                    </Link>
                    <MdArrowForwardIos className="text-gray-600 text-xs mt-0.5" />
                    <p className="text-md md:text-lg text-gray-800">
                        IR3 Flame Detectors
                    </p>
                </div>
            </div>

            <div className="px-2 xl:px-20 py-4 xl:py-6">
                <div className="flex flex-col-reverse lg:flex-row gap-8 items-start justify-start">

                    <div className="w-full lg:w-auto">
                        <div className="py-2">
                            <Link to="/products">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className="text-xl text-gray-900 uppercase group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Products
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Fire Alarm Systems
                                    </h1>
                                    {isOpen ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen && (
                                    <div className="mt-4 bg-white px-4 py-3">
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center py-1 border-b border-gray-300 cursor-pointer" onClick={() => setIsAddressableOpen(!isAddressableOpen)}>
                                                <h1 className="text-lg font-semibold text-gray-800 mb-2 mt-1">
                                                    Addressable Systems
                                                </h1>
                                                {isAddressableOpen ? (
                                                    <SlArrowUp className="text-gray-500 w-4 h-4" />
                                                ) : (
                                                    <SlArrowDown className="text-gray-500 w-4 h-4" />
                                                )}
                                            </div>
                                            {isAddressableOpen && (
                                                <div>
                                                    <Link to="/address">
                                                        <h2 className={`text-md mt-4 mb-3 pl-3 ${currentPath === "/address" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>Addressable Systems TOP</h2>
                                                    </Link>

                                                    <Link to="/n3060">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n3060" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N3060
                                                        </h2>
                                                    </Link>
                                                    <Link to="/n765">
                                                        <h2 className={`text-md mb-3 pl-3 ${currentPath === "/n765" ? "text-green-600" : "text-gray-600 hover:text-green-600"}`}>N765
                                                        </h2>
                                                    </Link>
                                                    <div className="border-b border-gray-300"></div>
                                                </div>
                                            )}

                                            <Link to="/smoke">
                                                <div className="py-1 border-b border-gray-300">
                                                    <h1 className={`text-lg font-semibold mt-1 mb-2 ${currentPath === "/smoke" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Aspirating Smoke Detector (Protecview)</h1>
                                                </div>
                                            </Link>
                                            <Link to="/other">
                                                <div className="py-1"><h1 className={`text-lg font-semibold mt-1 ${currentPath === "/other" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>Common Devices</h1>
                                                </div>
                                            </Link>
                                            <Link to="/flame">
                                                <div className="py-1"><h1 className={`text-lg font-semibold mt-1 ${currentPath === "/flame" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                    IR3 Flame Detectors
                                                </h1>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen1(!isOpen1)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Nitrogen Gas Fire Suppression Systems
                                    </h1>
                                    {isOpen1 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen1 && (
                                    <div className="mt-4 bg-white px-4 py-4">
                                        <div className="space-y-2">
                                            <Link to="/nn100">
                                                <div className="border-b border-gray-300 pb-3">
                                                    <h2 className={`text-lg font-semibold ${currentPath === "/nn100" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Engineered Type (NN100)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/nn100">
                                                <div className="pb-1 mt-1">
                                                    <h2 className="text-lg font-semibold text-gray-800 hover:text-green-600 mt-2">Package Type</h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <div className="bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                <div className="group flex justify-between items-center cursor-pointer" onClick={() => setIsOpen2(!isOpen2)}>
                                    <h1 className="text-xl text-gray-800 group-hover:text-green-600 transition-colors duration-300 flex-1 pr-3">
                                        Foam Extinguishing Systems
                                    </h1>
                                    {isOpen2 ? (
                                        <IoIosArrowUp className="text-green-600 w-6 h-6" />
                                    ) : (
                                        <IoIosArrowDown className="text-green-600 w-6 h-6" />
                                    )}
                                </div>

                                {isOpen2 && (
                                    <div className="mt-4 bg-white px-2 xl:px-4 py-2 xl:py-4">
                                        <div className="space-y-2">
                                            <Link to="/foam">
                                                <div className="border-b border-gray-300 pb-2">
                                                    <h2 className={`text-lg font-semibold mb-1 ${currentPath === "/foam" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        High Expansion Foam (Perf-EX)
                                                    </h2>
                                                </div>
                                            </Link>
                                            <Link to="/foamm">
                                                <div className="pb-1 mt-2">
                                                    <h2 className={`text-lg font-semibold  mt-2 ${currentPath === "/foamm" ? "text-green-600" : "text-gray-800 hover:text-green-600"}`}>
                                                        Package Type (MIDEX III)
                                                    </h2>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="py-2">
                            <Link to="/video">
                                <div className="group flex justify-between items-center bg-gray-200 px-4 py-4 w-full lg:w-72 shadow-sm">
                                    <h1 className={`text-xl flex-1 pr-3 transition-colors duration-300 ${currentPath === "/video" ? "text-green-600" : "text-gray-800 group-hover:text-green-600"}`}>
                                        Product Videos
                                    </h1>
                                    <span className="bg-green-600 text-white w-6 h-6 flex items-center justify-center text-sm flex-shrink-0">
                                        <FaArrowRight />
                                    </span>
                                </div>
                            </Link>
                        </div>
                    </div>

                    {/* NN100 Systems */}
                    <div className="px-2 xl:px-4 ">
                        <div className="block md:hidden w-fit mb-6">
                            <div className="flex items-center gap-3 bg-gray-200 text-gray-700 text-sm font-medium px-6 py-2 shadow-sm">
                                <FaArrowLeftLong className="w-3 h-3" />
                                <Link to="/products" className="hover:underline">
                                    Back to PRODUCTS
                                </Link>
                            </div>
                        </div>

                        <div className="flex flex-col items-start w-full">
                            <h1 className="text-2xl xl:text-4xl font-semibold">IR3 Flame Detectors</h1>
                            <div className="border-t-4 border-green-700 mt-4 w-full max-w-6xl" />
                        </div>

                        <div className="flex flex-col md:flex-row items-start w-full gap-8 mt-4">
                            <div className="w-full md:w-[300px] flex-shrink-0 mt-5">
                                <img src={flame} alt="Protecview" className="w-full h-full object-cover" />
                            </div>

                            <div className="flex-1">
                                <p className="text-gray-700 text-justify text-md mt-6 leading-relaxed">
                                    Nohmi's infrared three-wavelength flame detector quickly detects fire even in places with ventilation flow, external air, or high ceilings where detection is often difficult for the ordinary detectors. This high-sensitivity detector is suitable not only for large spaces but also for outdoor facilities.
                                </p>
                            </div>
                        </div>

                        <div className="pt-10">
                            <h1 className="text-2xl xl:text-4xl font-semibold text-gray-800">Product Data Sheets</h1>

                            <div className="flex w-20 h-1 mt-4">
                                <div className="w-1/2 bg-green-700" />
                                <div className="w-1/2 bg-gray-400" />
                            </div>

                            <div className="flex flex-col items-start w-full mt-6">
                                <h1 className="text-2xl xl:text-4xl font-semibold text-green-700">
                                    IR3 Flame Detectors
                                </h1>
                                <div className="border-t-4 border-gray-400 mt-4 w-full max-w-6xl" />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8 mb-10">

                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <img src={flame1} alt="Address" className="w-full h-full object-cover" />
                                        </div>

                                        <div className="w-full flex flex-col mt-4">
                                            <h1 className="text-xl font-semibold mb-3">Non-Explosion-Proof Type</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pdf1} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        PDCJ001-D
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <img src={flame2} alt="Address" className="w-full h-full object-cover" />
                                        </div>

                                        <div className="w-full flex flex-col mt-4">
                                            <h1 className="text-xl font-semibold mb-3">Explosion-Proof Type</h1>
                                            <div className="flex items-center gap-1 flex-nowrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pdf2} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 flex-nowrap">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150 whitespace-nowrap">
                                                        PDCJ002-E
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-2" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <img src={flame3} alt="Address" className="w-full h-full object-cover" />
                                        </div>

                                        <div className="w-full flex flex-col mt-4">
                                            <h1 className="text-xl font-semibold mb-3">Addressable Flame Detector</h1>
                                            <div className="flex items-center gap-1 flex-wrap">
                                                <MdKeyboardArrowRight className="w-5 h-5 text-green-700" />
                                                <a href={pdf3} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
                                                    <h2 className="text-lg text-green-700 border-b border-transparent hover:border-green-700 pb-[2px] transition-all duration-150">
                                                        FDCJ004-D
                                                    </h2>
                                                    <GrDocumentPdf className="w-7 h-7 text-red-600 cursor-pointer ml-3" />
                                                </a>
                                            </div>
                                        </div>
                                    </div>                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <Footer />
            </div>
        </>
    )
}

export default Flame
